import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from 'app/auth/service';

import { Permission } from '../models/permission';
import { User } from '../models/user';
import { UserOAuth } from '../models/user-oauth';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _router: Router, private _authenticationService: AuthenticationService) {}

  // canActivate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const userOAuth: UserOAuth = this._authenticationService.userOAuthValue;
    const user: User = this._authenticationService.currentUserValue;

    if (userOAuth && user) {
      if (state.url.indexOf('admin') > 0 && (user.admin == false || user.admin == null) && user.superAdmin == false) {
        this._router.navigate(['/portal/home']);
        return false;
      }
      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    let buf = new Uint8Array(1);
    window.crypto.getRandomValues(buf);
    let stateRequest = buf[0].toString();
    let urlCIAM = `https://login.microsoftonline.com/${process.env.TENANT}/oauth2/v2.0/authorize?client_id=${process.env.CLIENTID}&response_type=${process.env.RESPONSETYPE}&redirect_uri=${process.env.REDIRECTURI}&response_mode=${process.env.RESPONSEMODE}&scope=${process.env.SCOPE}&state=${stateRequest}`;

    location.href = urlCIAM;
    return false;
  }
}
